export const VIEW_TYPE = {
    TABLE: "Bảng",
    TAGS: "Thẻ"
};

export const XML_TAB_CONFIG: { [key: string]: any } = {
    XML0: {
        title: "Bảng Check-in",
        code: "XML0",
        urlData: "CHI_TIEU_TRANG_THAI_KCB.DSACH_TRANG_THAI_KCB.TRANG_THAI_KCB",
    },
    XML1: {
        title: "XML1 - Tổng hợp",
        code: "XML1",
        urlData: "TONG_HOP",
    },
    XML2: {
        title: "XML2 - Thuốc",
        code: "XML2",
        urlData: "CHITIEU_CHITIET_THUOC.DSACH_CHI_TIET_THUOC.CHI_TIET_THUOC",
    },
    XML3: {
        title: "XML3 - Dịch vụ, Vật tư",
        code: "XML3",
        urlData: "CHITIEU_CHITIET_DVKT_VTYT.DSACH_CHI_TIET_DVKT.CHI_TIET_DVKT",
    },
    XML4: {
        title: "XML4 - Cận lâm sàng",
        code: "XML4",
        urlData: "CHITIEU_CHITIET_DICHVUCANLAMSANG.DSACH_CHI_TIET_CLS.CHI_TIET_CLS",
    },
    XML5: {
        title: "XML5 - Diễn biến lâm sàng",
        code: "XML5",
        urlData: "CHITIEU_CHITIET_DIENBIENLAMSANG.DSACH_CHI_TIET_DIEN_BIEN_BENH.CHI_TIET_DIEN_BIEN_BENH",
    },
};

export const XML_ERROR_COLUMN = [
	{
		name: 'Lỗi',
		field: 'errorMessage',
		cellStyle: {
			minWidth: '100px',
            maxWidth: '400px',
		},
        render: (data: any) => {
            return (
                <pre className="text-label-input font-sans mb-0">
                    {data?.errorMessage ?? ''}
                </pre>
            )
        }
	},
];